import { render, staticRenderFns } from "./CodeOfConduct.vue?vue&type=template&id=3dc0c928&scoped=true"
import script from "./CodeOfConduct.vue?vue&type=script&lang=js"
export * from "./CodeOfConduct.vue?vue&type=script&lang=js"
import style0 from "./CodeOfConduct.vue?vue&type=style&index=0&id=3dc0c928&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc0c928",
  null
  
)

export default component.exports